import { render, staticRenderFns } from "./AddTeamCard.vue?vue&type=template&id=264d824c&scoped=true"
import script from "./AddTeamCard.vue?vue&type=script&lang=js"
export * from "./AddTeamCard.vue?vue&type=script&lang=js"
import style0 from "./AddTeamCard.vue?vue&type=style&index=0&id=264d824c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d824c",
  null
  
)

export default component.exports